import { createContext } from 'react';

export interface ExitModalsCtx {
  openSkipToRecom: (opts: {
    onSkip: () => void;
    onCloseExperience: () => void;
  }) => void;
  closeSkipToRecom: () => void;
  openExitSurvey: (opts: {
    onCloseSideBar: () => void;
    onCloseModal?: () => void;
  }) => void;
  closeExitSurvey: () => void;
}

export const ExitModalsContext = createContext<ExitModalsCtx | undefined>(
  undefined,
);
